import React, { useState, useContext, useEffect } from "react";
import BusquedaClienteContextProvider, {
    BusquedaClienteContext,
    ACTIONS
} from "../../context/BusquedaClienteProvider";
import "../../styles/busquedaCliente.scss";
import { ApplicationPropertiesContext } from "../../../../common/context/ApplicationPropertiesProvider"
import BusquedaTable from "../BusquedaTable";
import "../BusquedaTable/index"
import Loading from "../../../../common/components/Loading";
import { CGE } from "../../../../common/components/CGE";
import { getPathName } from "../../../../common/utils/utilsFunc";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

const Direccion = ({ hideSearch, changeInputNumClient, inputForms, setGlobalAlert, setNumIdEstasSinLuz, setNumIdPagoEnLinea }) => {
    const properties = useContext(ApplicationPropertiesContext);
    const [verifReCaptcha, setVerifReCaptcha] = useState(false);
    const [state, dispatch] = useContext(BusquedaClienteContext);
    const [isTableVisible, setIsTableVisible] = useState(false);
    const [inputComuna, setInputComuna] = useState("");
    const [inputCalle, setInputCalle] = useState("");
    const [cityCode, setCityCode] = useState("");
    const [inputDomicilio, setInputDomicilio] = useState("");
    const [inputNDepto, setInputNDepto] = useState("");
    const [listDirection, setListDirection] = useState([]);
    const [loading, setLoading] = React.useState(false);
    const [optAutoComplete, setOptAutoComplete] = useState([]);
    const [inputValidate, setInputValidate] = React.useState(false);
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    let streetOptions = [];
    let classCalle = null;

    let optionsComuna = [
        { value: '', label: '[Seleccione Comuna]' },
    ];

    function sanitizeAddressNumber(value) {
        return (value || "").replace(/[^0-9]/g, "").slice(0, 10);
    }

    function validateAddressFields() {
        const domicilio = (inputDomicilio || "").trim();
        const depto = (inputNDepto || "").trim();

        if (domicilio && !/^\d{1,10}$/.test(domicilio)) {
            setGlobalAlert("El campo Nº Domicilio debe contener solo números y máximo 10 caracteres.", "warning", true, "Advertencia");
            return false;
        }

        if (depto && !/^\d{1,10}$/.test(depto)) {
            setGlobalAlert("El campo Nº Depto / Nº Casa debe contener solo números y máximo 10 caracteres.", "warning", true, "Advertencia");
            return false;
        }

        return true;
    }

    function elementInsideAnother() {
        if (getPathName() === "para-estar-informados-completa-tus-datos") {
            return true;
        } else {
            return false;
        }
    }

    function handleClick() {
        if (inputComuna === "" || inputCalle === "" || cityCode === "") {
            hideTable();
            setInputValidate(true);
            setGlobalAlert("Complete todos los campos obligatorios.", "warning");
            return;
        }

        if (!verifReCaptcha) {
            setInputValidate(false);
            setGlobalAlert("Falta validar que no eres un Robot.", "warning");
            return;
        }

        if (!validateAddressFields()) {
            hideTable();
            return;
        }

        setInputValidate(false);

        if (state.calles && state.calles.calles) {
            const street = state.calles.calles.find((street) => street.descripcion === inputCalle);
            const calleResponse = street ? street.codigoSAP : null;

            if (!calleResponse) {
                hideTable();
                setGlobalAlert("No hay direcciones que coincidan con la búsqueda.", "warning", true, "Advertencia");
                return;
            }

            setLoading(true);
            dispatch({
                payload: [calleResponse, inputDomicilio, inputNDepto],
                type: ACTIONS.SET_BODY_CLIENTE_DIRECCION,
            });
            showTable();
        } else {
            hideTable();
            setGlobalAlert("No hay direcciones que coincidan con la búsqueda.", "warning", true, "Advertencia");
        }
    }

    function showTable() {
        if (!isTableVisible) {
            setIsTableVisible(true);
        }
    }

    function hideTable() {
        if (isTableVisible) {
            setIsTableVisible(false);
        }
    }

    function handleComuna(value) {
        setInputComuna(value);
        setCityCode(value);

        if (value !== "") {
            const splitHandleComuna = value.split(",");
            setInputCalle("");
            dispatch({
                payload: splitHandleComuna[0],
                type: ACTIONS.SET_COMUNA_ID,
            });
            dispatch({
                payload: splitHandleComuna[1],
                type: ACTIONS.SET_CODIGO_CIUDAD,
            });
        }
    }

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    useEffect(() => {
        if (state.responseDireccion) {
            setLoading(false);
            const dataResponseDireccion = state.responseDireccion;
            if (dataResponseDireccion.code == 0) {
                setListDirection(dataResponseDireccion?.items);
            } else {
                hideTable();
                setGlobalAlert("No hay direcciones que coincidan con la búsqueda.", "warning", true, "Advertencia");
            }
        }
    }, [state.responseDireccion]);

    useEffect(() => {
        if (classCalle && classCalle.refs && classCalle.refs.input) {
            classCalle.refs.input.className = 'autofocus-style';
        }
    }, []);

    useEffect(() => {
        if (!state.calles) {

        } else {
            if (state.calles.calles) {
                state.calles.calles.map((item) => {
                    streetOptions.push(item.descripcion);
                });
            }
            setOptAutoComplete(streetOptions);
        }
    }, [state.calles]);

    if (state.comuna?.code === 0) {
        state.comuna?.comunas.forEach((item) => {
            optionsComuna.push({ label: item.nomComuna, value: [item.id, item.codigoSAP] });
        });
    }

    return (
        <div className="cge-busqueda">
            <CGE.FormsField
                handleChange={(e) => handleComuna(e.target.value)}
                horizontal={true}
                labelName="Comuna:"
                listOptions={optionsComuna}
                mandatoryElement={true}
                typeElement="select"
                typeFormElement="text"
                hasError={inputValidate && !inputComuna}
                msgError="Debes selecionar una comuna"
            />

            <CGE.FormsField
                horizontalAutocomplete={true}
                handleChange={(e) => setInputCalle(e.target.value)}
                labelName="Calle:"
                mandatoryElement={true}
                autocomplete={true}
                atcGetItemValue={item => item}
                atcItems={optAutoComplete}
                atcMenuStyle={{
                    borderRadius: '0px',
                    border: '1px solid black',
                    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                    background: '#fff',
                    fontSize: '15px',
                    fontWeight: 'normal',
                    left: '0',
                    maxHeight: '300px',
                    overflow: 'auto',
                    padding: '0 0',
                    position: 'absolute',
                    top: '40px',
                    zIndex: '1'
                }}
                atcOnChange={(e) => setInputCalle(e.target.value)}
                atcOnSelect={(val) => setInputCalle(val)}
                atcRef={el => classCalle = el}
                atcRenderItem={
                    (item, highlighted) =>
                        <div
                            className="street-options pl-3"
                            style={{
                                backgroundColor: highlighted ? '#00a7e1' : '#fff',
                                color: highlighted ? '#fff' : '#000000',
                            }}
                        >
                            {item}
                        </div>
                }
                atcShouldItemRender={(item, value) => item.toLowerCase().indexOf(value.toLowerCase()) > -1}
                atcValue={inputCalle}
                atcWrapperStyle={{ display: 'block' }}
                hasError={inputValidate && !inputCalle}
                msgError="Debes ingresar una calle"
            />

            <CGE.FormsField
                className="cge-busqueda__width-residence-house"
                handleChange={(e) => setInputDomicilio(sanitizeAddressNumber(e.target.value))}
                horizontal={true}
                labelName="Nº Domicilio (solo números):"
                typeElement="input"
                typeFormElement="text"
                value={inputDomicilio}
                maxLength={10}
            />

            <CGE.FormsField
                className="cge-busqueda__width-residence-house"
                handleChange={(e) => setInputNDepto(sanitizeAddressNumber(e.target.value))}
                horizontal={true}
                labelName="Nº Depto / Nº Casa (solo números):"
                typeElement="input"
                typeFormElement="text"
                value={inputNDepto}
                maxLength={10}
            />

            <div className="col-md-12 px-0">
                <CGE.FieldRecaptcha
                    horizontal={true}
                    onChange={onChangeReCaptcha}
                    sitekey={properties.api_key_recaptcha}
                />
            </div>

            <div className="d-flex justify-content-center" >
                <CGE.InlineRow>
                    {elementInsideAnother() && <CGE.InlineCol>
                        <CGE.Button
                            label="Volver"
                            onClick={() => { hideSearch(false) }}
                            size="sm"
                            type="secondary"
                        />
                    </CGE.InlineCol>}
                    <CGE.InlineCol>
                        <CGE.Button
                            label="Buscar"
                            onClick={handleClick}
                            size={elementInsideAnother() ? "sm" : false}
                            type="primary"
                        />
                    </CGE.InlineCol>
                </CGE.InlineRow>
            </div>

            {isTableVisible &&
                <>
                    <CGE.Spacing type="md" />
                    <BusquedaTable
                        dataTable={listDirection}
                        flagRoute={0}
                        hideSearch={hideSearch}
                        changeInputNumClient={changeInputNumClient}
                        inputForms={inputForms}
                        setNumIdEstasSinLuz={setNumIdEstasSinLuz}
                        setNumIdPagoEnLinea={setNumIdPagoEnLinea}
                    />
                </>
            }

            {loading && <Loading />}
        </div>
    );
};

const DireccionWithProvider = ({ hideSearch, changeInputNumClient, inputForms, setGlobalAlert, setNumIdEstasSinLuz, setNumIdPagoEnLinea }) => (
    <BusquedaClienteContextProvider>
        <Direccion
            changeInputNumClient={changeInputNumClient}
            hideSearch={hideSearch}
            inputForms={inputForms}
            setGlobalAlert={setGlobalAlert}
            setNumIdEstasSinLuz={setNumIdEstasSinLuz}
            setNumIdPagoEnLinea={setNumIdPagoEnLinea}
        />
    </BusquedaClienteContextProvider>
);

export default DireccionWithProvider;